import { ApplicationError } from '../application-error';

export class UserNotAuthorizedError extends ApplicationError {
  public override readonly name: string;

  constructor(message: string) {
    super(message);
    this.name = 'UserNotAuthorizedError';
  }
}
